var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"endDate"},[_vm._v(_vm._s(_vm.returnDiffTime(_vm.competitionData)))])
}
var staticRenderFns = []

export { render, staticRenderFns }